<template>
  <div class="albumPage">
    <slot v-if="!isPC">
      <!-- <i class="el-icon-arrow-left" @click="$router.back(-1)"></i> -->
    </slot>
    <div class="number" v-if="albumList[typeCurr]">{{imgIndex[typeCurr]}}/{{albumList[typeCurr].length}}</div>
    <div class="atypebox">
      <span v-for="(item,index) in albumType" :class="{'active':index==typeCurr}" @click="changeType(index)">{{item.name}}<slot v-if="isPC"><slot v-if="albumList[index]">（{{albumList[index].length}}）</slot><slot v-else><i class="el-icon-loading"></i></slot></slot></span>
    </div>
    <swiper ref="swiperTop" v-if="albumType.length>0" v-for="(item,index) in albumType" :options="swiperOption" class="swiper-wrap" v-show="typeCurr==index" :key="index">
      <swiper-slide v-for="(item1,index1) in albumList[index]" :key="index1" v-if="albumList[index]">
        <div class="imgbox"><img v-lazy="item1.path +'&type=1'" /></div>
      </swiper-slide>
      <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
      <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
export default {
  name: 'slider',
  components: {
    swiper,
    swiperSlide,
  },
  props:{
    eId:String,
    aId:String,
  },
  data () {
    const that = this;
    return {
      isPC:that.$store.state.isPC,
      phone:'',
      albumType:[],
      albumList:[],
      typeCurr:0,
      imgIndex:[],
      nextType:false,
      prevType:false,
      pushNext:0,
      swiperOption: {
        zoom:true,
        notNextTick: true,
        speed: 200,
        grabCursor: true,
        lazy:{
          loadPrevNext: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChangeTransitionEnd: function() {
            that.$set(that.imgIndex,that.typeCurr,this.realIndex+1)
          },
          progress(progress){
            if(progress>1.01){
              that.nextType=true;
            }else{
              that.nextType=false;
            }
            if(progress<-0.01){
              that.prevType=true;
            }else{
              that.prevType=false;
            }
          },
          touchEnd(){
            if(that.nextType&&that.typeCurr<that.albumType.length-1){
              that.typeCurr++
            }else if(that.prevType&&that.typeCurr>0){
              that.typeCurr--
            }
          },
        },
      },
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  mounted() {
    if(this.eId){
      this.getAlbumType(this.eId);
    }
    if(this.aId){
      this.getHouseAlbumType(this.aId);
    }
  },
  methods:{
    getAlbumType:function(id){
      this.$http.get('/api/estate/getEstateAlbumList?estateId='+id).then((response)=>{
        this.albumType = response.data.result.albumList;
        for (var i = 0; i < this.albumType.length; i++) {
          this.imgIndex.push(1)
        }
        this.getAlbumList(this.albumType[this.pushNext].pkId)
      }).catch((response)=>{
        console.log(response)
      })
    },
    getAlbumList:function(id){
      this.$http.get('/api/estate/getEstateAlbumPhotoList?albumId='+id).then((response)=>{
        this.albumList.push(response.data.result.photoList)
        if(this.albumList.length<this.albumType.length){
          this.pushNext++
          this.getAlbumList(this.albumType[this.pushNext].pkId)
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
    getHouseAlbumType:function(id){
      this.albumType.push('');
      this.imgIndex.push(1);
      this.$http.get('/api/apartment/getHousePhotos?houseId='+id).then((response)=>{
        this.albumList.push(response.data.result.mfangPhotoList);
      }).catch((response)=>{
        console.log(response)
      })
    },
    changeType(index){
      this.typeCurr = index;
    }
  }
}
</script>

<style scoped>
  .albumPage img{display:block;max-width:100%;margin:0 auto;}
  .albumPage>>>.swiper-container,.albumPage>>>.swiper-wrapper,.albumPage>>>.swiper-slide{height:100%;}
  .albumPage>>>.swiper-slide{display:table;}
  .imgbox{display:table-cell;vertical-align:middle;}
@media (max-width:768px){
  .albumPage{color:#fff;background:#000;}
  .number{position:absolute;top:15px;left:15px;font-size:16px;}
  .el-icon-arrow-left{position:absolute;top:13px;left:10px;font-size:24px;cursor:pointer;z-index:9;}
  .albumPage{position:absolute;left:0;right:0;top:0;bottom:0;}
  .atypebox{position:absolute;bottom:0;left:0;right:0;z-index:8;width:100%;background:linear-gradient(rgba(0,0,0,0),#000);font-size:14px;line-height:42px;text-align:center;display:table;}
  .atypebox span{display:table-cell;}
  .atypebox span.active{color:#ffd03d;}
  .swiper-button-white{display:none!important;}
}
@media (min-width:769px){
  .albumPage{width:75%;height:100%;position:relative;background:#000;padding-right:25%;}
  .number{position:absolute;bottom:15px;left:75%;font-size:16px;z-index:1;text-indent:15px;}
  .atypebox{position:absolute;right:0;top:0;bottom:0;background:#fff;width:25%;padding:100px 20px 40px;box-sizing:border-box;}
  .atypebox span{display:block;line-height:36px;background:#eee;padding:0 10px;border-radius:2px;margin-top:10px;cursor:pointer;}
  .atypebox span.active{background:#333;color:#ffd03d;}
  img[lazy=error]{height:400px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Album.vue